module.exports = __webpack_public_path__ + "img/psm_logo-inverse.a397cf65.png";